<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div
        class="page-actions"
        style="display: flex; justify-content: space-between"
      >
        <div class="select">
          <!-- <div class="item">
            <div class="ipt">
              是否启用杠杆：
              <el-switch v-model="leverSwitch" active-text="开" inactive-text="关">
              </el-switch>
            </div>
          </div> -->
          <!-- <div class="item">
            <div class="ipt">
              交易对开关：
              <el-switch
                v-model="tradeSwitch"
                active-text="开"
                inactive-text="关"
              >
              </el-switch>
            </div>
          </div> -->
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="tradeSwitch"
                placeholder="交易对开关"
                clearable
                size="mini"
              >
                <el-option
                  v-for="item in tradeSwitchArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input placeholder="主键ID" clearable v-model="id" size="mini">
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="symbolId"
                placeholder="交易对ID"
                clearable
                size="mini"
              >
                <el-option
                  v-for="item in symbolList"
                  :key="item.id"
                  :label="item.symbol"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <el-button
              size="mini"
              type="primary"
              @click="handleSearch({ page: 1 })"
              >查询</el-button
            >
          </div>

          <div class="item">
            <el-button size="mini" type="primary" @click="show('新增')"
              >新增交易对</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="900">
        <el-table-column label="交易对" prop="symbol" />
        <el-table-column label="taker费率" prop="takerFee" />
        <el-table-column label="maker费率" prop="makerFee" />
        <el-table-column prop="" label="杠杆开关">
          <template slot-scope="scope">
            <span>{{ scope.row.leverSwitch ? "开" : "关" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="交易开关">
          <template slot-scope="scope">
            <span>{{ scope.row.tradeSwitch ? "开" : "关" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="show('编辑', scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="paginationHandle"
      >
      </pagination>

      <el-dialog
        :title="title"
        :visible="dialogVisible"
        width="400px"
        @close="close"
        :destroy-on-close="true"
      >
        <el-form
          ref="formData"
          :model="formData"
          size="medium"
          label-width="100px"
        >
          <el-form-item label="杠杆开关" prop="">
            <el-switch v-model="formData.leverSwitch"> </el-switch>
          </el-form-item>
          <el-form-item label="交易开关" prop="">
            <el-switch v-model="formData.tradeSwitch"> </el-switch>
          </el-form-item>
          <el-form-item label="maker费率" prop="">
            <el-input-number
              :min="0"
              v-model="formData.makerFee"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="taker费率" prop="">
            <el-input-number
              :min="0"
              v-model="formData.takerFee"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="交易对ID" prop="">
            <el-select
              v-model="formData.symbolId"
              placeholder="交易对ID"
              clearable
            >
              <el-option
                v-for="item in symbolList"
                :key="item.id"
                :label="item.symbol"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="handleSave">确定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "../api";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      // leverSwitch: false,
      tradeSwitch: "",
      tradeSwitchArr: [
        { label: "开", value: true },
        { label: "关", value: false },
      ],
      id: "",
      symbolId: "",
      symbolList: [],
      tabList: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      dialogVisible: false,
      title: "新增",
      formData: {
        leverSwitch: false,
        tradeSwitch: false,
        makerFee: 0,
        takerFee: 0,
        symbolId: "",
      },
    };
  },
  computed: {},
  mounted() {
    api.getSymbolList({ type: "SPOT" }).then((res) => {
      if (res.code == 0) {
        console.log("res.data", res.data);
        this.symbolList = res.data;
      }
    });
    this.handleSearch();
  },
  methods: {
    handleSearch(data = {}) {
      api
        .getSpotSymbolPage({
          id: this.id,
          // leverSwitch: this.leverSwitch,
          symbolId: this.symbolId,
          tradeSwitch: this.tradeSwitch,
          ...this.pagination,
          ...data,
        })
        .then((res) => {
          if (res.code == 0) {
            const { totalCount, list } = res.data;
            this.tabList = list;
            this.totalCount = totalCount;
          }
        });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },
    show(str, row) {
      if (row) {
        this.formData = JSON.parse(JSON.stringify(row));
        this.formData.createdTime = undefined;
        this.formData.updatedTime = undefined;
      }
      this.title = str;
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.formData = {
        leverSwitch: false,
        tradeSwitch: false,
        makerFee: 0,
        takerFee: 0,
        symbolId: "",
      };
    },
    handleSave() {
      if (this.formData.id == "") {
        return this.$message.error("请选择交易对ID");
      }
      api.updateSpotSymbol(this.formData).then((res) => {
        if (res.code == 0) {
          this.$message.success(this.title + "成功");
          this.close();
          this.handleSearch();
        }
      });
    },
  },
};
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
